import { Tab, Tabs, Typography } from '@material-ui/core';
import { CertificadoRecebiveisApiResponse, EmissaoStatus, GrupoAcesso } from 'common/genericTypes';
import Chip from 'components/chip';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import SuspensaoHistorico, { SuspensaoHistoricoKind } from 'components/suspensaoHistorico';
import { LgSpace } from 'm2m.components';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { RootState } from 'store';
import { DetalhesCaracteristicas } from './caracteristicas';
import { DetalhesCriteriosRemuneracao } from './criteriosRemuneracao';
import { DetalhesDocumentos } from './documentos';
import { DetalhesEventosFinanceiros } from 'common/detalhes/eventosFinanceiros';
import { initialCertificadoRecebiveis } from './initialCertificadoRecebiveis';
import Liquidacoes from './liquidacoes';
import Historico from './historico';
import { DetalhesAditamento } from 'pages/instrumentos/detalhes/aditamentos';

type ComponentParams = { certificadoRecebiveisId: string };
type ComponentState = { initialTab?: number };

type Props = RouteComponentProps<ComponentParams, {}, ComponentState>;

const Detalhes: React.FC<Props> = (props) => {
  const { certificadoRecebiveisId } = props.match.params;

  const [tabValue, setTabValue] = useState<number>(props.location.state?.initialTab ?? 0);
  const [crDetalhes, setCrDetalhes] = useState<CertificadoRecebiveisApiResponse>(initialCertificadoRecebiveis);
  const [loadedDetalhes, setLoadedDetalhes] = useState<Boolean>(false);

  const dispatch = useDispatch();
  const isUsuarioControlesInternos = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.ControlesInternos
  );
  const isUsuarioOperacoes = useSelector(
    (state: RootState) => state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes
  );
  const { getCertificadoRecebiveisDetalhes } = useSelector((state: RootState) => state.certificadoRecebiveisApi);

  const getDetalhes = useCallback(async () => {
    try {
      const result = await getCertificadoRecebiveisDetalhes(dispatch, certificadoRecebiveisId, true);
      setCrDetalhes(result);
      setLoadedDetalhes(true);
    } catch (error) {}
  }, [dispatch, getCertificadoRecebiveisDetalhes, certificadoRecebiveisId]);

  useEffect(() => {
    getDetalhes();
  }, [getDetalhes]);

  return (
    <div style={{ marginRight: 40 }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="h1">
          {'CR-'}
          {crDetalhes.codigo ?? crDetalhes.ticket}
        </Typography>
        {crDetalhes.suspenso && (
          <Chip
            size="medium"
            label="SUSPENSO"
            color="error"
            style={{
              margin: 20,
            }}
          />
        )}
        {crDetalhes.hasPagamentosInadimplentes && <Chip size="small" label="INADIMPLENTE" color="error" />}
      </div>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Características da Emissão" value={0} />
          <Tab label="Critérios de Remuneração" value={1} />
          <Tab label="Eventos Financeiros" value={2} />
          <Tab label="Documentos" value={3} />
          <Tab label="Aditamentos" value={7} />
          <Tab label="Suspensões" value={4} />
          <Tab label="Histórico" value={5} />
          {(isUsuarioControlesInternos || isUsuarioOperacoes) &&
            crDetalhes &&
            [EmissaoStatus.AguardandoLiquidacao, EmissaoStatus.Emitido, EmissaoStatus.ParcialmenteEmitido].includes(
              crDetalhes.statusEmissao
            ) && <Tab label="Liquidações" value={6} />}
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <DetalhesCaracteristicas certificadoRecebiveis={crDetalhes} />}
      {tabValue === 1 && <DetalhesCriteriosRemuneracao certificadoRecebiveis={crDetalhes} />}
      {tabValue === 2 && <DetalhesEventosFinanceiros eventosFinanceiros={crDetalhes} />}
      {tabValue === 3 && <DetalhesDocumentos certificadoRecebiveis={crDetalhes} />}
      {tabValue === 4 && (
        <SuspensaoHistorico
          kind={SuspensaoHistoricoKind.InstrumentoFinanceiro}
          registroHistoricos={crDetalhes.registro.registroHistoricos}
        />
      )}
      {tabValue === 5 && <Historico certificadoRecebiveis={crDetalhes} />}
      {tabValue === 6 && loadedDetalhes && (
        <Liquidacoes
          onConfirmarLiquidacaoSuccess={getDetalhes}
          liquidacaoDireta={crDetalhes.criteriosRemuneracao.liquidacaoDireta}
          aguardandoLiquidacao={crDetalhes.statusEmissao === EmissaoStatus.AguardandoLiquidacao}
          precoUnitarioLiquidacao={crDetalhes.criteriosRemuneracao.precoUnitarioLiquidacao}
          certificadoRecebiveisId={certificadoRecebiveisId}
          instrumentoFinanceiroGuid={crDetalhes.instrumentoFinanceiroGuid}
        />
      )}
      {tabValue === 7 && <DetalhesAditamento documentos={crDetalhes.instrumentoFinanceiroGuid} />}
    </div>
  );
};

export default Detalhes;
